import { render, staticRenderFns } from "./BCXUnregisteredUser.vue?vue&type=template&id=07f9767f&scoped=true"
import script from "./BCXUnregisteredUser.vue?vue&type=script&lang=ts"
export * from "./BCXUnregisteredUser.vue?vue&type=script&lang=ts"
import style0 from "./BCXUnregisteredUser.vue?vue&type=style&index=0&id=07f9767f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f9767f",
  null
  
)

export default component.exports